export const DOCTOR_PROFILE_PATH = "/doctor-profile";
export const CHAT_BOT_CONSTANTS = {
  COMPATIBILITY_ERROR:
    "Por favor usar Chrome o Firefox si quiere disponer de la funcionalidad de voz",
  RECOGNITION_LANG: "es-CO",
  DF_MESSENGER: {
    ELEMENTS: {
      BASE: "df-messenger",
      CHAT: "df-messenger-chat",
      USER_INPUT: "df-messenger-user-input",
      INPUT: "input",
      MESSAGE_LIST: "df-message-list",
      DIV: "div",
      VIDEO: "video" as "video",
      SOURCE: "source" as "source"
    },
    LISTENER: {
      RECEIVED: "df-response-received",
      LOADED: "dfMessengerLoaded"
    },
    MESSAGE_CLASS: "message bot-message bot-animation",
    HEIGHT_MODIFIER: `div.chat-wrapper[opened="true"] { height: 450px; width: 340px; margin-right: 20px; } button#widgetIcon { box-shadow: none; background: transparent} button#widgetIcon div #closeSvg { fill: #0b3352}`,
    OPEN_CHAT: "div[class='chat-wrapper']",
    MESSAGE_LIST_ID: "messageList"
  },
  ROUTE_INCLUDE: "Navegando",
  ACTION_INCLUDE: "Mostrando",
  ROUTES: [
    { PATH: "/form-templates", PATH_TXT: "a Plantillas de Formularios" },
    { PATH: "/lists", PATH_TXT: "a Listas" },
    { PATH: "/info-group", PATH_TXT: "a Grupos de Información" },
    { PATH: "/user-templates", PATH_TXT: "a Plantillas de Usuarios" },
    { PATH: "/users", PATH_TXT: "a Usuarios" },
    { PATH: "/roles", PATH_TXT: "a Roles" },
    { PATH: "/service-templates", PATH_TXT: "a Plantillas de Servicios" },
    { PATH: "/session-templates", PATH_TXT: "a Plantillas de Sesiones" },
    { PATH: "/assign-service", PATH_TXT: "a Asignar Servicio" },
    { PATH: "/price-levels", PATH_TXT: "a Niveles de Precio" },
    { PATH: "/save-order-template", PATH_TXT: "a Plantilla de Orden" },
    { PATH: "/", PATH_TXT: "a Home" },
    { PATH: "/dependencies", PATH_TXT: "a Dependencias" },
    { PATH: "/campus", PATH_TXT: "a Sedes" },
    { PATH: "/space", PATH_TXT: "a Espacios" },
    { PATH: "/availability/", PATH_TXT: "a Disponibilidades" },
    { PATH: "/general-rules", PATH_TXT: "a Reglas" },
    { PATH: "/template-pdf", PATH_TXT: "a Plantillas PDF" },
    {
      PATH: "/notification-templates",
      PATH_TXT: "a Plantillas de Notificaciones"
    },
    { PATH: "/admin-dashboard", PATH_TXT: "a Tablero Administrativo" },
    { PATH: "/load-orders", PATH_TXT: "a Cargar Ordenes" },
    { PATH: "/save-medical-order", PATH_TXT: "a Crear Orden" },
    { PATH: DOCTOR_PROFILE_PATH, PATH_TXT: "a Agenda Médico" }
  ],
  ACTIONS: [
    { ACTION: "task", ACTION_TEXT: "Tareas" },
    { ACTION: "documents", ACTION_TEXT: "Documentos" },
    { ACTION: "message", ACTION_TEXT: "Mensajes" },
    { ACTION: "timeline", ACTION_TEXT: "Linea de tiempo" }
  ],
  PAYLOAD: {
    VIDEO_TYPE: "video",
    COMPATIBILITY: {
      TYPE: "info",
      TITLE: "Compatibilidad"
    }
  },
  EVENT_LISTENER: "click",
  ATTRIBUTE: "opened"
};
export const WINDOW_SIZES = {
  MIN_SIZE: 500,
  DEFAULT_SIZE: 800
};

export const IMG_SOURCE =
  "https://storage.googleapis.com/cloudprod-apiai/70cfd0eb-763f-4dfc-8bec-c3eed1f9d598_x.png";

export const CHAT_TOOLTIP = "Chat Neumobot";
